import React from 'react';
import './LayoutDetails.css';

export default function LayoutDetails({ layoutDetails = [] }) {
  const uniqueSorted = (arr) =>
    Array.from(new Set(arr.filter((v) => v !== undefined))).sort(
      (a, b) => a - b,
    );
  // Rows = distinct X values; Columns = distinct Y values
  const xValues = uniqueSorted(layoutDetails.map((i) => i?.slot?.x));
  const yValues = uniqueSorted(layoutDetails.map((i) => i?.slot?.y));

  const physicalFridgeConfig =
    layoutDetails.length > 0 ? layoutDetails[0].physicalFridgeConfig ?? '' : '';

  const itemsAt = (x, y) =>
    layoutDetails.filter((i) => i?.slot?.x === x && i?.slot?.y === y);

  return (
    <div className="layout-details-container">
      <p className="layout-details-note">
        ** The below Layout Details reflect the planogram that is currently live
        and do not show upcoming, scheduled changes. Use the Planogram tool to
        edit or schedule updates. **
      </p>
      <div className="layout-details-header">
        Current Physical Fridge Config:{' '}
        {physicalFridgeConfig ? physicalFridgeConfig : 'MISSING'}
      </div>

      <div className="layout-details-header">Current Layout Slots:</div>

      <div
        className="layout-slots-grid-wrapper"
        style={{
          gridTemplateColumns: `repeat(${
            yValues.length || 1
          }, minmax(75px, 1fr))`,
        }}
      >
        {xValues.map((x) =>
          yValues.map((y) => {
            const items = itemsAt(x, y);
            return (
              <div
                className="layout-slots-cell-outer"
                key={`${x}|${y}|${items.length}`}
                title={`(${x},${y})`}
              >
                {items.length > 0 ? (
                  items.map((cell, idx) => (
                    <div key={idx} className="layout-slots-cell-inner">
                      {`(${x},${y})`} &nbsp; {cell?.vendItemName ?? ''}
                    </div>
                  ))
                ) : (
                  <div className="layout-slots-empty">N/A</div>
                )}
              </div>
            );
          }),
        )}
      </div>
    </div>
  );
}
